import React from "react";

export default () => <div className="text-center">Loading</div>;
